import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "@/store";
import { selectStringParam } from "@/store/selectors";

const selectInventoryList = (state: RootState) => state.offline.inventoryList;
const selectPointsInventories = (state: RootState) =>
    state.offline.pointsInventories;
const selectPlans = (state: RootState) => state.offline.plans;
const selectFacts = (state: RootState) => state.offline.facts;
const selectIgnoreRemainingsOrders = (state: RootState) =>
    state.offline.ignoreRemainingsOrders;
const selectPriceLists = (state: RootState) => state.offline.priceLists;
const selectPointsPriceListsId = (state: RootState) =>
    state.offline.pointsPriceLists;
const selectPromoList = (state: RootState) => state.offline.promoList;
const selectPromosVocabulary = (state: RootState) =>
    state.offline.promosVocabulary;
const selectDebts = (state: RootState) => state.offline.debts;

export const selectPriceListIdById = createSelector(
    [selectPointsPriceListsId, selectStringParam],
    (priceListIds, pointId) => priceListIds?.[pointId],
);

export const selectPriceListById = createSelector(
    [selectPriceLists, selectStringParam],
    (priceLists, priceListId) => priceLists?.[priceListId],
);

export const selectPlanById = createSelector(
    [selectPlans, selectStringParam],
    (plans, pointId) => {
        return plans?.[pointId];
    },
);

export const selectInventoryListById = createSelector(
    [selectInventoryList, selectStringParam],
    (inventoryList, storageId) => {
        return inventoryList?.[storageId];
    },
);

export const selectFactById = createSelector(
    [selectFacts, selectStringParam],
    (facts, pointId) => {
        return facts?.[pointId];
    },
);

export const selectIgnoreRemainingsByOrderId = createSelector(
    [selectIgnoreRemainingsOrders, selectStringParam],
    (ignoreRemainingsOrders, orderId) => {
        return ignoreRemainingsOrders?.[orderId];
    },
);

export const selectPointInventoryById = createSelector(
    [selectPointsInventories, selectStringParam],
    (pointsInventories, pointId) => {
        return pointsInventories?.[pointId];
    },
);

export const selectPromosVocabularyById = createSelector(
    [selectPromosVocabulary, selectStringParam],
    (promosVocabulary, id) => {
        return promosVocabulary?.[id];
    },
);

export const selectPromosById = createSelector(
    [selectPromoList, selectStringParam],
    (promoList, id) => {
        return promoList?.[id];
    },
);

export const selectPointDebtsByPointId = createSelector(
    [selectDebts, selectStringParam],
    (debts, pointId) => {
        return debts?.[pointId];
    },
);
